// extracted by mini-css-extract-plugin
var _1 = "TextWithIcon-module__animatedBackground--vh40Z";
var _2 = "TextWithIcon-module__iconContainer--xMYXW";
var _3 = "TextWithIcon-module__multiLine--oKuUV";
var _4 = "TextWithIcon-module__singleLine--T5edZ";
var _5 = "TextWithIcon-module__textContainer--dQ88R";
var _6 = "TextWithIcon-module__truncate--ya7oX";
var _7 = "TextWithIcon-module__wrap--urzMZ";
var _8 = "TextWithIcon-module__wrappingGroup--decR3";
export { _1 as "animatedBackground", _2 as "iconContainer", _3 as "multiLine", _4 as "singleLine", _5 as "textContainer", _6 as "truncate", _7 as "wrap", _8 as "wrappingGroup" }
